export default "/assets/hallway.111f670b9a015fd5d44f03eb7ba0d097.png";